import { apiQuery, atsApiQuery } from '@/store/query';

const FILTER_STRUCTURE_MAPPING = {
  application_status: { name: 'application_status', id: 'application_status' },
  application_source: { name: 'title', id: 'id' },
  application_source_type: { name: 'title', id: 'title' },
  application_rejection_reason: { name: 'title', id: 'id' },
  application_rejection_type: { name: 'title', id: 'title' },

  job: { name: 'title', id: 'id' },
  job_status: { name: 'status', id: 'status' },
  job_sourcer: { name: 'name', id: 'id' },
  job_recruiter: { name: 'name', id: 'id' },
  job_hiring_manager: { name: 'name', id: 'id' },
  job_department: { name: 'title', id: 'id' },
  job_subdepartment: { name: 'title', id: 'id' },
  job_office: { name: 'title', id: 'id' },
  job_suboffice: { name: 'title', id: 'id' },

  candidate_gender: { name: 'gender', id: 'gender' },
  candidate_recruiter: { name: 'name', id: 'id' },
};

/**
 * This filter is for ATS Reports in reports v2
 */
export const atsFilterApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getOptions: builder.query({
        transformResponse: (response, _, { attribute }) => {
          const options = response?.data?.options ?? [];
          const mapping = FILTER_STRUCTURE_MAPPING[attribute];
          return options.map((option) => ({
            name: option[mapping.name],
            id: option[mapping.id],
          }));
        },
        query: ({ category, attribute }) => {
          return {
            method: 'get',
            url: `/reports/filter/ats/${category}?attribute=${attribute}`,
          };
        },
      }),
    };
  },
});

export const { useGetOptionsQuery } = atsFilterApi;

/**
 * This filter is for reports for ATS module
 */
export const atsReportsFilterApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getFilterOptions: builder.query({
        query: ({ attribute, scope }) => {
          return {
            method: 'get',
            url: `/reports/filters/list/?attribute=${attribute}${
              scope ? `&scope=${scope}` : ''
            }`,
          };
        },
      }),
    };
  },
});

export const { useGetFilterOptionsQuery } = atsReportsFilterApi;
